// import { IconEye } from "@tabler/icons-react";
// import React from "react";

// // type Column<T> = {
// //   label: string;
// //   render: (item: T, index: number) => React.ReactNode;
// //   className?: string;
// // };

// type Column<T> = {
//   label: React.ReactNode;
//   render: (item: T, index: number) => React.ReactNode;
//   className?: string;
// };

// interface ListViewProps<T> {
//   data: T[];
//   multiData?: T[];
//   columns: Column<T>[];
//   onRowClick?: (item: T) => void;
//   mailDivClassName?: string; // <-- Add this line
//   trClassName?: string; // <-- Add this line
//   tdClassName?: string; // <-- Add this line
//   tableType?: string;
//   TableClassName?: string;
//   splitToggle?: boolean;
// }

// function ListView<T>({
//   data,
//   columns,
//   multiData,
//   tableType,
//   TableClassName,
//   onRowClick,
//   mailDivClassName = "rounded-3xl",
//   trClassName,
//   tdClassName,
//   splitToggle,
// }: ListViewProps<T>) {
//   return (
//     <div
//       className={`bg-[#F7F6F2] rounded-tl-none pt-2 rounded-3xl ${TableClassName}`}
//     >
//       <div className={`overflow-auto bg-[#FCFDF8]  ${mailDivClassName}`}>
//         <table className="w-full text-sm whitespace-nowrap">
//           <thead className="text-[#131327]/70 border-[#d2d2d2] border-b border-dashed">
//             <tr>
//               {columns?.map((col, i) => (
//                 <th
//                   key={i}
//                   className={`text-left font-semibold px-6 py-3 ${
//                     col.className || ""
//                   } ${col.label === "Status" ? "text-center" : ""} ${
//                     col.label === "Actions" ? "text-center" : ""
//                   }`}
//                 >
//                   {col.label}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody className="divide-y  ">
//             {data?.map((item, idx) => (
//               <tr
//                 key={idx}
//                 onClick={() => onRowClick?.(item)}
//                 className={`hover:bg-[#FBD037]/20 group cursor-pointer ${trClassName}`}
//               >
//                 {columns.map((col, i) => (
//                   <td
//                     key={i}
//                     className={`px-6 py-3 text-[#212121]  ${
//                       i === 0 ? " " : i === columns.length - 1 ? " " : ""
//                     } ${tdClassName}`}
//                   >
//                     {col.render(item, idx)}
//                   </td>
//                 ))}
//               </tr>
//             ))}

//             {splitToggle && (
//               <>
//                 {multiData?.map((item, idx) => (
//                   <tr className="bg-white border-t border-white ">
//                     <td className=" text-[#212121] h-[67px]">
//                       <div className="flex justify-center items-center h-full">
//                         <div className="w-px h-16 bg-gray-300"></div>
//                         <div className="w-3/6 h-px bg-gray-300"></div>
//                       </div>
//                     </td>
//                     <td className="px-6 py-3 text-[#212121]">#04564665-1</td>
//                     <td className="px-6 py-3 text-[#212121]">SKU123</td>
//                     <td className="px-6 py-3 text-[#212121]">Alok Kumar</td>
//                     <td className="px-6 py-3 text-[#212121]">25</td>

//                     <td className="px-6 py-3 text-[#212121]"> Self</td>
//                     <td className="px-6 py-3 text-[#212121]">
//                       4 Aug 2025, 6:40 AM
//                     </td>
//                     <td className="px-6 py-3 text-[#212121]">
//                       <div className="flex justify-center">
//                         {true && (
//                           <span className="px-4 py-1.5 text-xs font-medium rounded-full bg-[#FF4848]/20 border border-[#FF4848]">
//                             Pending
//                           </span>
//                         )}
//                         {false && (
//                           <span className="px-4 py-1.5 text-xs font-medium rounded-full bg-[#20BF55]/20 border border-[#20BF55]">
//                             Completed
//                           </span>
//                         )}
//                       </div>
//                     </td>
//                     <td className="text-center px-6 py-3 text-[#212121]">
//                       <div className="text-center">
//                         <button className="p-2 border rounded-full bg-[#F7F6F2]">
//                           <IconEye size={22} />
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default ListView;

import { IconEye } from "@tabler/icons-react";
import React from "react";

type Column<T> = {
  label: string | React.ReactNode;
  render?: (item: T, index: number) => React.ReactNode;
  className?: string;
  children?: Column<T>[]; // 👈 allow sub-columns
};

interface ListViewProps<T> {
  data: T[];
  columns: Column<T>[];
  multiData?: T[];
  onRowClick?: (item: T) => void;
  mainDivClassName?: string;
  mailDivClassName?: string;
  trClassName?: string;
  tdClassName?: string;
  thClassName?: string;
  tableType?: string;
  ActionClassName?: string;
  TableClassName?: string;
  renderExpandedContent?: (data: T) => React.ReactNode; // 👈 Optional expanded content
  expandedRows?: Set<number>; // 👈 Track expanded rows
  splitToggle?: boolean;
}

function ListView<T>({
  data,
  columns,
  onRowClick,
  TableClassName,
  tableType,
  mailDivClassName = "p-0 rounded-r-3xl rounded-b-3xl",
  mainDivClassName = "bg-[#F7F6F2] pt-2 rounded-r-3xl rounded-b-3xl",
  trClassName = "hover:bg-[#FBD037]/20 group",
  thClassName,
  tdClassName,
  ActionClassName,
  splitToggle,
  multiData,
  renderExpandedContent,
  expandedRows,
}: ListViewProps<T>) {
  const hasGroups = columns.some((c) => c.children && c.children.length > 0);
  const hasExpandedContent = !!renderExpandedContent;

  return (
    <div className={`${mainDivClassName}`}>
      <div className={`overflow-auto bg-[#FCFDF8] ${mailDivClassName}`}>
        <table className="w-full text-sm whitespace-nowrap">
          <thead
            className={`text-[#131327]/70 border-gray-300 border-b border-dashed ${thClassName}`}
          >
            {/* Top row */}
            <tr>
              {/* {hasExpandedContent && (
                <th
                  rowSpan={hasGroups ? 2 : 1}
                  className="w-12 px-2 py-1 border-r border-dashed border-gray-300"
                />
              )} */}
              {columns.map((col, i) => {
                const isGroup = col.children && col.children.length > 0;
                return (
                  <th
                    key={i}
                    colSpan={isGroup ? col.children!.length : 1}
                    rowSpan={isGroup ? 1 : hasGroups ? 2 : 1}
                    className={`${
                      isGroup
                        ? "text-center border-b border-dashed"
                        : "text-left"
                    } font-semibold px-6 py-1 border-r last:text-center last:border-none border-dashed border-gray-300 
                    ${
                      typeof col?.label === "string" &&
                      col?.label === "Status" &&
                      "text-center"
                    }`} // 👈 Safe string check
                  >
                    {col.label}
                  </th>
                );
              })}
            </tr>

            {/* Second row for grouped subheaders */}
            {hasGroups && (
              <tr>
                {/* {hasExpandedContent && (
                  <th className="border-r border-dashed border-gray-300" />
                )} */}
                {columns.flatMap((col, i) =>
                  col.children
                    ? col.children.map((child, j) => (
                        <th
                          key={`${i}-${j}`}
                          className="text-center font-semibold px-6 py-1 border-r border-dashed border-gray-300 text-xs text-gray-500"
                        >
                          {child.label}
                        </th>
                      ))
                    : []
                )}
              </tr>
            )}
          </thead>

          <tbody className="divide-y">
            {data?.map((item, idx) => {
              const key = (item as any)?.id?.toString?.() ?? idx.toString();
              const idNum = parseInt(key, 10); // 👈 Parse for consistency
              const isExpanded = hasExpandedContent && expandedRows?.has(idNum);

              return (
                <React.Fragment key={key}>
                  {/* Main row */}
                  <tr
                    onClick={() => onRowClick?.(item)}
                    className={`cursor-pointer ${trClassName} ${
                      isExpanded ? "bg-gray-50" : ""
                    }`}
                  >
                    {/* {hasExpandedContent && (
                      <td className="px-2 py-4 border-r border-dashed border-gray-300" />
                    )} */}

                    {columns.flatMap((col, i) => {
                      if (col.children && col.children.length > 0) {
                        return col.children.map((child, j) => (
                          <td
                            key={`${i}-${j}`}
                            className={`px-6 text-center py-4 text-[#212121] ${tdClassName}`}
                          >
                            {child.render ? child.render(item, idx) : null}
                          </td>
                        ));
                      }
                      return (
                        <td
                          key={i}
                          className={`px-6 py-4 text-[#212121] ${
                            typeof col?.label === "string" &&
                            col?.label === "Status" &&
                            "text-center"
                          } ${tdClassName}`} // 👈 Safe string check
                        >
                          {col.render ? col.render(item, idx) : null}
                        </td>
                      );
                    })}
                  </tr>

                  {/* Expanded content row */}
                  {isExpanded && renderExpandedContent && (
                    <tr>
                      <td
                        colSpan={
                          (hasExpandedContent ? 1 : 0) +
                          columns.reduce(
                            (total, col) =>
                              total + (col.children ? col.children.length : 1),
                            0
                          )
                        }
                        className="p-0 border-b border-gray-200"
                      >
                        {renderExpandedContent(item)}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}

            {splitToggle && (
              <>
                {multiData?.map((item, idx) => (
                  <tr className="bg-white border-t border-white ">
                    <td className=" text-[#212121] h-[67px]">
                      <div className="flex justify-center items-center h-full">
                        <div className="w-px h-16 bg-gray-300"></div>
                        <div className="w-3/6 h-px bg-gray-300"></div>
                      </div>
                    </td>
                    <td className="px-6 py-3 text-[#212121]">#04564665-1</td>
                    <td className="px-6 py-3 text-[#212121]">SKU123</td>
                    <td className="px-6 py-3 text-[#212121]">Alok Kumar</td>
                    <td className="px-6 py-3 text-[#212121]">25</td>

                    <td className="px-6 py-3 text-[#212121]"> Self</td>
                    <td className="px-6 py-3 text-[#212121]">
                      4 Aug 2025, 6:40 AM
                    </td>
                    <td className="px-6 py-3 text-[#212121]">
                      <div className="flex justify-center">
                        {true && (
                          <span className="px-4 py-1.5 text-xs font-medium rounded-full bg-[#FF4848]/20 border border-[#FF4848]">
                            Pending
                          </span>
                        )}
                        {false && (
                          <span className="px-4 py-1.5 text-xs font-medium rounded-full bg-[#20BF55]/20 border border-[#20BF55]">
                            Completed
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="text-center px-6 py-3 text-[#212121]">
                      <div className="text-center">
                        <button className="p-2 border rounded-full bg-[#F7F6F2]">
                          <IconEye size={22} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ListView;
